import { render, staticRenderFns } from "./pc-input-text.vue?vue&type=template&id=f8fb24fc&scoped=true&"
import script from "./pc-input-text.vue?vue&type=script&lang=ts&"
export * from "./pc-input-text.vue?vue&type=script&lang=ts&"
import style0 from "./pc-input-text.vue?vue&type=style&index=0&id=f8fb24fc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../entries/portal/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8fb24fc",
  null
  
)

export default component.exports